import { render } from "./reviews-com.vue?vue&type=template&id=158d2449&scoped=true"
import script from "./reviews-com.vue?vue&type=script&lang=js"
export * from "./reviews-com.vue?vue&type=script&lang=js"

import "./reviews-com.vue?vue&type=style&index=0&id=158d2449&scoped=true&lang=css"

import exportComponent from "/Users/achinthaprabasha/Desktop/work/yathra/yathra-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158d2449"]])

export default __exports__